import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent, CfetService, CFETILMEndpointsConstant, UrlUtil, LoaderService, CfetPageNamesConstant } from '../../../cfet-core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-utf-landing-new',
    templateUrl: './utf-landing-new.component.html',
    styleUrls: ['./utf-landing-new.component.scss'],
    standalone: false
})

export class UtfLandingNewComponent extends CfetBaseComponent implements OnInit {
  showLoading = false;
  affiliationCode: UntypedFormControl;
  public openBadCodeModal = '';
  public showBadCodeModal = false;
  isNavigatingToEligibility = false;
  public affiliationCodeForm: UntypedFormGroup;
  isSpaOrg: boolean;
  copyAffiliationCode: any;
  isInvalidCode: boolean;
  OrgDetails: any = {};
  returnUrl: string;
  cId = '';

  constructor(private cfetService: CfetService,
    private router: Router,
    private activatedroute: ActivatedRoute,
    private loaderService: LoaderService,
    private urlUtil: UrlUtil,
    private formBuilder: UntypedFormBuilder,
    private title: Title) { super(); }

  ngOnInit(): void {
    this.title.setTitle(this.cfetTitles.landing.htmlTitle);
    if (sessionStorage.getItem('orgInfo') && Object.keys(sessionStorage.getItem('orgInfo')).length !== 0) {
      sessionStorage.removeItem('orgInfo');
    }
    if (sessionStorage.getItem('orgDetailInfo') && Object.keys(sessionStorage.getItem('orgDetailInfo')).length !== 0) {
      sessionStorage.removeItem('orgDetailInfo');
    }
    sessionStorage.clear();
    this.affiliationCode = new UntypedFormControl('',);
    this.affiliationCodeForm = this.formBuilder.group({
      affiliationCode: this.affiliationCode
    });
    this.activatedroute.queryParamMap.subscribe(params => {
      this.setAffiliationCode(params);
    });
  }

  setAffiliationCode(params) {
    if (params && params['affiliationcode']) {
      this.affiliationCode.setValue(params['affiliationcode']);
    } else if (params && params['params'] && params['params']['affiliationcode']) {
      this.affiliationCode.setValue(params['params']['affiliationcode']);
    }
    const event = { type: 'click' };
    if (this.affiliationCode.value) {
      this.onSubmitAffiliationCode(event);
    }
    this.setReturnUrlAndCidToSessionStorage(params);
  }

  setReturnUrlAndCidToSessionStorage(params) {
    if (params && params['returnURL']) {
      this.returnUrl = params['returnURL'];
    }
    if (params && params['params'] && params['params']['returnURL']) {
      this.returnUrl = params['params']['returnURL'];
    }
    if (params && params['c_id_available']) {
      this.cId = params['c_id_available'];
    }
    if (params && params['params'] && params['params']['c_id_available']) {
      this.cId = params['params']['c_id_available'];
    }
    if (this.returnUrl && this.returnUrl !== '') {
      sessionStorage.setItem('returnUrl', JSON.stringify(this.returnUrl));
    }
    if (this.cId && this.cId !== '') {
      sessionStorage.setItem('c_id', JSON.stringify(this.cId));
    }
  }

  get f() { return this.affiliationCodeForm.controls; }

  onSubmitAffiliationCode(event) {
    if ((event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) &&
      (this.affiliationCode.value !== '' && this.affiliationCode.value !== null)) {
      this.showLoading = true;
      if (this.affiliationCode.value.length > 0) {
        const param = { retcode: this.affiliationCode.value };
        const url = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_AFFILIATION_CODE, param)}`;
        this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
          this.setOrgDetails(data);
        }, (_error) => {
          this.showLoading = false;
          this.copyAffiliationCode = this.affiliationCode.value;
          this.isInvalidCode = true;
          this.openBadCodeModal = 'open';
          this.showBadCodeModal = true;
        });
      }
      // Override the loaderOverlay background-color from styles.scss
      setTimeout(function () {
        if (document.getElementById('loaderOverlay')) {
          document.getElementById('loaderOverlay').style.cssText = 'background-color: #000000 !important';
        }
      }, 100);
    }
  }

  setOrgDetails(data) {
    if (data && data.profile) {
      data.profile.forEach(val => {
        if (val.attribute_name === 'isSpaOrg' && val.attribute_value === 'TRUE') {
          this.isSpaOrg = true;
        }
      });
      this.OrgDetails.orgProfileInfo = data;
      this.OrgDetails.orgid = data.orgid;
      this.OrgDetails.orgName = data.orgName;
      this.OrgDetails.isSpaOrg = this.isSpaOrg;
      this.OrgDetails.affiliationCode = this.affiliationCode.value.replace(/ /g, '');
      sessionStorage.setItem('orgInfo', JSON.stringify(this.OrgDetails));
      this.showLoading = false;
      if (this.isSpaOrg) {
        sessionStorage.setItem('fromOrgAssignment', 'true');
        this.router.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF]);
      } else {
        this.router.navigate([CfetPageNamesConstant.AFFILIATION_CODE_UTF]);
      }
    }
  }

  eligibility(event) {
    if (event.type === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.isNavigatingToEligibility = true;
      const skipRedirect = sessionStorage.getItem('skipOrgAssignmentRedirect');
      if (skipRedirect === 'true') {
        sessionStorage.removeItem('skipOrgAssignmentRedirect');
      } else {
        this.router.navigate(['/signup/orgAssignment']);
      }
      sessionStorage.setItem('fromOrgAssignment', 'true');
    }
  }

  closeBadCodeModal(event) {
    if (event === 'modalClose') {
      this.openBadCodeModal = 'close';
      this.showBadCodeModal = false;
    }
  }
}
